/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {useStyles} from '@ion/dls/src/components/search/SearchResultsCount';
import GlobalGroupsSearch from '@ion/features/src/global-groups/search';

interface GroupQueryResultProps {
  searchValue: string;
}

/**
 * Component to display Global Account Search results count
 * ```typescript
 *  import GlobalGroupsSearchCount from '@ion/dls/src/components/groupchooser/GlobalGroupsSearchCount';
 *
 *  <GlobalGroupsSearchCount searchValue={searchValue}/>
 * ```
 */
const GlobalGroupsSearchCount = ({searchValue}: GroupQueryResultProps) => {
  const classes = useStyles({paddingLeft: '0px'});
  const cutoffLimit = 50;
  const count: number =  GlobalGroupsSearch.fetchResultsCount();
  return (
    <div className={classes.searchResultsText}>
      {translate(`common:search.${count !== 1 ? 'results_plural' : 'results'}`, {
        val           : `"${searchValue}"`,
        count         : count,
        interpolation : {escapeValue: false}
      })}<br />
      {count > cutoffLimit && translate('common:search.tooManyResults')}
    </div>
  );
};

export default GlobalGroupsSearchCount;
